
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thriftyadvice/privacy-policy",
      function () {
        return require("private-next-pages/thriftyadvice/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thriftyadvice/privacy-policy"])
      });
    }
  